<template>
  <div class="country">
    <a :href="href">
      <div class="country-container">
        <div class="flag-circle">
          <img
            class="flag"
            :src="require(`../assets/images/countries/${image}`)"
            :alt="name"
          />
        </div>
        <p class="country-name">{{ name }}</p>
        <p class="language">({{ language }})</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Country',
  props: {
    country: {
      type: Object,
      required: true,
    },
  },
  data() {
    const { name, href, image, language } = this.country;

    return {
      name,
      href,
      image,
      language,
    };
  },
};
</script>

<style lang="scss" scoped>
.country {
  margin-left: 50px;
  margin-right: auto;
  margin-bottom: 20px;
  height: 26px;
  display: flex;
  align-items: center;
  flex-direction: row;

  @media screen and (min-width: 720px){
    display: inline-block;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 85px;
    height: 130px;
    width: 200px;
  }

  a {
    text-decoration: none;

    &:hover {
      .country-name, .language {
        color: #44b69f;
        transition-duration: 0.3s;
      }

      .flag-circle {
        box-shadow: 2px 2px 2px rgba(20, 72, 98, 0.3);
        transition-duration: 0.3s;

        @media screen and (min-width: 720px){
          box-shadow: 4px 4px 4px rgba(20, 72, 98, 0.3);
        }
      }
    }
  }
}

.country-container {
  display: flex;
  align-items: center;
  flex-direction: row;

  @media screen and (min-width: 720px){
    flex-direction: column;
    text-align: center;
  }
}

.country p {
  display: inline;

  @media screen and (min-width: 720px){
    display: block;
  }
}

.country-name, .language {
  font-size: 16px;
  margin-bottom: auto;
  margin-top: auto;

  @media screen and (min-width: 720px){
    font-size: 18px;
  }
}

.country-name {
  font-family: 'Montserrat-Medium';
  font-weight: 600;
  color: #4a4a4a;
  margin-left: 20px;

  @media screen and (min-width: 720px){
    margin-left: auto;
    margin-right: auto;
    margin-top: 25px;
  }

}

.language {
  font-family: 'Montserrat-ExtraLight';
  font-weight: 200;
  color: #4a4a4a;
  margin-left: 8px;

  @media screen and (min-width: 720px){
    margin-left: auto;
    margin-right: auto;
    margin-top: 8px;
  }
}

.flag {
  display: inline-block;
  width: 26px;

  @media screen and (min-width: 720px){
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 52px;
  }
}

.flag-circle {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-block;

  @media screen and (min-width: 720px){
    width: 52px;
    height: 52px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Country.vue